/* eslint-disable */
import services from 'services';
import * as types from './mutation-types';

export default {
  // fetchInventoryByStore: async ({ commit }, { storeId, showingBy }) => {
  fetchInventoryByStore: async ({ commit }, { productId }) => {

    // const list = await services.InventoryService.getInventoryByStore(storeId, showingBy);
    const list = await services.InventoryService.getInventoryByStore(productId);
    commit(types.SET_LIST_INVENTORY, { list: list });
  },
  // setQuantityInventory: async ({ commit }, { data }) => {
  //   const list = await services.InventoryService.setQuantityInventory(data);
  //   // commit('SET_QUANTITY_INVENTORY', { data });
  //   commit(types.SET_LIST_INVENTORY, { list: list });
  // },
};
